import * as React from 'react';
import { BenefitsItem as TBenefitsItem } from '~/common/types/types';
import { FormattedMessage } from '~/components/common/common';
import { getValidClasses } from '~/helpers/helpers';
import { useSlideData } from '~/hooks/hooks';
import { getSliderSide } from '~/components/sections/reviews/helpers/helpers';
import * as styles from './benefits-item.module.scss';

type Props = {
  item: TBenefitsItem;
};

const BenefitsItem: React.FC<Props> = ({ item }) => {
  const { isActive, isNext, isPrev } = useSlideData();

  const side = getSliderSide(isNext, isPrev);
  return (
    <article className={getValidClasses(styles.wrapper, side && styles[side])}>
      <div
        className={getValidClasses(
          styles.item,
          isActive && styles.itemActive,
          styles.decoration,
          styles[`decoration${item.decorationKey}`],
        )}
      >
        <div className={styles.info}>
          <h3 className={styles.title}>
            <FormattedMessage message={item.title} />
          </h3>
          <p className={styles.description}>
            <FormattedMessage message={item.description} />
          </p>
        </div>
      </div>
    </article>
  );
};

export { BenefitsItem };
